"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link() {
  return _react2.default.createElement(
    "g",
    { id: "link" },
    _react2.default.createElement("path", {
      d: "M83.0224182,418.034159 C66.2332905,401.008162 56.9128319,378.020809 57.1132914,354.133627 C57.3137508,330.246445 67.0186913,307.418116 84.0912056,290.675153 L166.744097,207.831356 L127.911489,169.147214 L45.258597,251.991011 C7.6643582,288.022392 -7.50446285,341.50553 5.59025449,391.856031 C18.6849718,442.206531 58.002048,481.575853 108.40927,494.811675 C158.816491,508.047498 212.456477,493.086646 248.684464,455.687198 L331.337356,372.807845 L292.86101,334.123703 L210.208118,416.9675 C193.505052,433.980013 170.702095,443.655118 146.837176,443.855264 C122.972257,444.05541 100.009601,434.764124 83.0224182,418.034159 L83.0224182,418.034159 Z M188.119845,353.501329 L353.425629,187.778179 L312.811708,147.031831 L147.505924,312.754981 L188.119845,353.501329 Z M252.247089,44.8459621 L169.237935,127.725315 L208.070543,166.409457 L290.723435,83.5656597 C313.158944,60.2559105 346.476579,50.8870811 377.805505,59.078416 C409.13443,67.2697508 433.569403,91.7387134 441.671021,123.032772 C449.772639,154.32683 440.272413,187.5462 416.840348,209.858007 L334.187456,292.701804 L372.663802,331.385946 L455.672956,248.542149 C493.267195,212.510768 508.436016,159.02763 495.341299,108.677129 C482.246582,58.3266292 442.929505,18.9573071 392.522284,5.72148461 C342.115062,-7.51433785 288.475076,7.44651406 252.247089,44.8459621 L252.247089,44.8459621 Z",
      id: "Shape"
    })
  );
};

exports.default = Link;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Link.js
// module id = 2965
// module chunks = 4